import BigDataChart from "@/components/ui/chart/BigDataChart";
import DonutChart from "@/components/ui/chart/DonutChart";
import HorizontalBarChart from "@/components/ui/chart/HorizontalBarChart";
import VerticalBarChart from "@/components/ui/chart/VerticalBarChart";
import { WidgetType } from "@/types/widget";

import NoDataWidgetContent from "./NoDataWidgetContent";

interface WidgetConfigurationPreviewProps {
  widgetType: WidgetType;
  data: { name: string; value: string }[];
}
// need use REAL DATA after integrate with API
const WidgetConfigurationPreview = ({
  widgetType,
  data
}: WidgetConfigurationPreviewProps) => {
  const bigDataValue = 80;
  switch (widgetType) {
    case WidgetType.BAR_V:
      return (
        <VerticalBarChart
          data={data.map((item) => ({
            name: item.name,
            value: Number(item.value),
            key: Number(item.value)
          }))}
        />
      );
    case WidgetType.BAR_H:
      return <HorizontalBarChart data={data} />;
    case WidgetType.DONUT:
      return (
        <DonutChart
          data={data.map((item) => ({
            name: item.name,
            value: Number(item.value)
          }))}
        />
      );
    case WidgetType.LINE:
      return <NoDataWidgetContent />;
    case WidgetType.BIG_NUMBER:
      return <BigDataChart value={bigDataValue} type="MIN" />;

    default:
      return <NoDataWidgetContent />;
  }
};

export default WidgetConfigurationPreview;
